import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {finalize} from 'rxjs/operators';

import {UserContent} from 'app/profile/model/model';
import {getTranslation} from 'shared/helpers/get-translation';
import {NavService} from 'shared/nav/nav.service';
import { DefaultPage } from 'app/menu/components/default-page/default-page';
import { ContentService } from 'app/content/services/content.service';
import { CModule, CModuleService } from 'app/cmodule';

const LABEL_FORMAT: string = 'dddd, DD.MM.YYYY';

@Component({
  selector: 'certificates-page',
  templateUrl: 'certificates-page.html',
  styleUrls: ['certificates-page.scss'],
})
export class CertificatesPage extends DefaultPage {

  public isLoading: boolean = false;
  public certificates: Array<UserContent>;
  public cmodules: Array<CModule>;

  constructor(
    private navService: NavService,
    private translateService: TranslateService,
    private contentService: ContentService,
    private cmoduleService: CModuleService,
  ) {
    super(navService);
  }

  public get hasCertificates(): boolean {
    return (this.certificates && this.certificates.length > 0) || (this.cmodules && this.cmodules.length > 0);
  }

  private ionViewWillEnter(): void {
    this.isLoading = true;
    this.contentService.getContents('certificate')
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe((userContents: Array<UserContent>) => {
        this.certificates = userContents.filter(userContent => userContent.state >= 8);
      });
    this.cmoduleService.getCModules('certificate')
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe((cmodules: Array<CModule>) => {
        this.cmodules = cmodules.filter((cmod) => cmod.state == 9);
      });
  }

  public getLocalizedDate(time: string): string {
    if ( time === undefined || time === null) {
      return '-';
    }
    return moment(time).format(LABEL_FORMAT);
  }

  public getLocalizedText(text: Dictionary<string>): string {
    return getTranslation(text, this.translateService);
  }

  public getPdf(userContent: UserContent, event: Event): void {
    if ( event !== undefined ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    this.contentService.getPdf(userContent._id, this.getLocalizedText(userContent.contentFull.title))
    .then((info) => {
      console.log(info);
    });
  }

  public getPdfCModule(cmodule: CModule, event: Event): void {
    if ( event !== undefined ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    this.contentService.getPdf(cmodule._id, this.getLocalizedText(cmodule.title), 'cmodule')
    .then((info) => {
      console.log(info);
    });
  }

}
